

.tabs {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
  align-items: center;
}

.trigger {
  display: flex;
  padding: 0.5rem 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  line-height: 1.25rem;
  color: var(--static-text-standard);
  background: var(--static-background-weak);
  font-size: var(--fs-normal);
  font-weight: 500;
  border: none;
  border-radius: 1rem;
  transition: all 150ms ease;
  cursor: pointer;
}

.trigger:hover {
  filter: brightness(0.98);
}

.trigger[data-state='active'] {
  color: var(--color-primary);
  background: var(--selectable-selected);
}

.content {
  margin-top: 1rem;
}